<template>
  <div>
    <div class="d-flex align-center text-center mb-8">
      <v-btn 
        large 
        dark
        color="#313a46"
        class="mr-1 elevation-0"
        icon 
        @click="pageReturn()"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <p class="title-page ma-0">Contabilizar NCM</p>
    </div>
  
  <v-row>
    <v-col cols="12" :xs="12" :md="6">
      <LinkComponent @onLinkEnd="init" :items="items" :empresaId="empresaId" />
    </v-col>
    <v-col cols="12" :xs="12" :md="6">
      <UnlinkComponent @onLinkEnd="init" :items="itemsVinculados" />
    </v-col>
  </v-row>
</div>
</template>

<script>
import centroCusto from "@/services/http/nfeNcm/CentroCusto";
import CentroCustoEmpresa from "../../../services/http/nfeNcm/CentroCustoEmpresa";
import LinkComponent from "./components/LinkComponent.vue";
import UnlinkComponent from "./components/UnlinkComponent.vue";

export default {
  components: {
    LinkComponent,
    UnlinkComponent,
  },
  data() {
    return {
      empresaId: "",
      items: [],
      itemsVinculados: [],
    };
  },
  methods: {
    async fetchcentroCusto() {
      try {
        let { data } = await centroCusto().show({ per_page: -1 });
        return data.data;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    pageReturn() {
      this.$router.go(-1);
    },
    async fetchLinked() {
      try {
        let { data } = await CentroCustoEmpresa().show({
          id_empresa: this.empresaId,
          status: 1,
        });
        return data.data || [];
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async init() {
      let centroCusto = await this.fetchcentroCusto();

      let centroCustoLinkados = await this.fetchLinked();
      centroCustoLinkados.forEach((link) => {
        centroCusto = centroCusto.filter((item) => {
          if (item.id !== parseInt(link.id_centro_custo)) {
            return true;
          }
        });
      });
      this.items = centroCusto;
      this.itemsVinculados = centroCustoLinkados;
    },
  },
  mounted() {
    this.empresaId = parseInt(this.$route.params.id);
    this.init();
  },
};
</script>
